import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CustomSvgIconName } from '@panaya/ui/p-icon/customize';
import { IconName, SvgIconName } from '@panaya/ui/p-icon';
import { ColorName } from '@panaya/ui/styles-to-code';

@Component({
    selector: 'p-dialog-header',
    template: `
        <div class="p-dialog-header" [ngClass]="{ 'fit-content': fitContentWidth }">
            <p-icon *ngIf="iconName" class="p-dialog-header-icon" [name]="iconName" [color]="iconColor" size="lg"></p-icon>
            <p-icon-image *ngIf="imgName" [name]="imgName" size="lg" class="p-dialog-header-icon"></p-icon-image>
            <h2 *ngIf="!titleToolTip" class="p-dialog-title p-headline-1">
                {{ isSentenceCase ? (title | sentenceCase) : title }}
            </h2>
            <ng-container *ngIf="titleToolTip">
                <h2
                    class="p-dialog-title p-headline-1"
                    [matTooltip]="isSentenceCase ? (titleToolTip | sentenceCase) : titleToolTip"
                    [showOnlyWhenEllipsis]="true"
                >
                    {{ isSentenceCase ? (title | sentenceCase) : title }}
                </h2>
            </ng-container>
            <p-icon class="p-dialog-header-info" *ngIf="infoTooltip" name="info" size="md" [matTooltip]="infoTooltip"></p-icon>
            <ng-content select="[rightContent]"></ng-content>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PDialogHeaderComponent {
    @Input() title?: string;
    @Input() isSentenceCase? = true;
    @Input() iconName?: IconName;
    @Input() iconColor!: ColorName;
    @Input() infoTooltip?: string;
    @Input() fitContentWidth = true;
    @Input() titleToolTip?: string;
    @Input() imgName?: SvgIconName | CustomSvgIconName;
}
